<template lang="pug">
    el-tabs(type="border-card")
      el-tab-pane(label="普通车")
        el-form(
          label-width="150px"
          :model="fixedBikeForm"
          :rules="fixedBikeRules"
          ref="fixedBikeForm"
        )
          el-form-item(label="实际车辆数:")
            span {{ city.actual }}
          el-form-item(label="当前定投车辆数:")
            span {{ city.fixed }}
          el-form-item(label="定投车辆数:" prop="fixedBike")
            el-input(v-model.number="fixedBikeForm.fixedBike" style="width: 174px")
          el-form-item
            el-button(type="success" @click="fixedBikeFormSubmit") 确认定投

      el-tab-pane(label="助力车")
        el-form(
          label-width="150px"
          :model="fixedBicycleForm"
          :rules="fixedBicycleRules"
          ref="fixedBicycleForm"
        )
          el-form-item(label="实际车辆数:")
            span {{ bicycle.actual }}
          el-form-item(label="当前定投车辆数:")
            span {{ bicycle.fixed }}
          el-form-item(label="定投车辆数:" prop="fixedBicycle")
            el-input(v-model.number="fixedBicycleForm.fixedBicycle" style="width: 174px")
          el-form-item
            el-button(type="success" @click="fixedBicycleFormSubmit") 确认定投
</template>

<script>
import { setBikeNumber, setFixedBicycle, queryCityFixedCount } from '@/api/user';

export default {
  name: 'BikeForm',
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      fixedBikeForm: {
        fixedBike: null,
      },
      fixedBicycleForm: {
        fixedBicycle: null
      },
      city: {},
      bicycle: {},
      fixedBikeRules: {
        fixedBike: [
          { required: true, message: '请填写定投车辆数', trigger: 'change' },
          {
            min: -1, type: 'number', message: '定投数需要大于等于-1', trigger: 'change'
          },
          // {
          //   validator: (rule, value, callback) => {
          //     if (this.city.actual >= value) {
          //       callback();
          //     } else {
          //       callback(new Error('定投车辆不能超过实际最大数量'));
          //     }
          //   },
          //   trigger: 'change'
          // }
        ],
      },
      fixedBicycleRules: {
        fixedBicycle: [
          { required: true, message: '请填写定投车辆数', trigger: 'change' },
          {
            min: -1, type: 'number', message: '定投数需要大于等于-1', trigger: 'change'
          },
          // {
          //   validator: (rule, value, callback) => {
          //     if (this.bicycle.actual >= value) {
          //       callback();
          //     } else {
          //       callback(new Error('定投车辆不能超过实际最大数量'));
          //     }
          //   },
          //   trigger: 'change'
          // }
        ]
      }
    };
  },
  async mounted() {
    const {
      data: {
        actualBikeCount, fixedBicycleCount, actualBicycleCount, fixedBikeCount
      }
    } = await queryCityFixedCount({ cityGuid: this.id });
    this.city = {
      actual: actualBikeCount,
      fixed: fixedBikeCount,
    };
    this.bicycle = {
      actual: actualBicycleCount,
      fixed: fixedBicycleCount,
    };
  },
  methods: {
    fixedBikeFormSubmit() {
      this.$refs.fixedBikeForm.validate(async (valid) => {
        if (valid) {
          const data = {
            ...this.fixedBikeForm,
            cityGuid: this.id
          };
          await setBikeNumber(data);
          this.$message.success('设置普通车定投数成功');
          this.$emit('submit');
        }
      });
    },
    fixedBicycleFormSubmit() {
      this.$refs.fixedBicycleForm.validate(async (valid) => {
        if (valid) {
          const data = {
            ...this.fixedBicycleForm,
            cityGuid: this.id
          };
          await setFixedBicycle(data);
          this.$message.success('设置助力车定投数成功');
          this.$emit('submit');
        }
      });
    }
  },
};
</script>
<style lang='less' scoped>
.custom--el-form-item{
  padding-left:40px;
}
.custom-title{
  text-align: left;
  padding-left: 5px;
  border-left: 4px solid ;
}
.custom--el-form-item-border{
  position: relative;
  &:before{
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    width: 90%;
    height: 100%;
    border-top: 1px solid #ccc;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/bikeForm.vue?602112d8